import Backbone from 'backbone'
import template from 'scoreboard/components/files/file-drop-overlay.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

// The file-drop-overlay is the overlay shown when a file is dropped over a view
// which accepts file uploads. Ex. Documents Overview & Documents Folder Overview (#21209)
var FileDropOverlay = Backbone.View.extend({

	className: 'file-drop-overlay is-not-displayed',

	events: {
		'dragover': 'drag',
		'dragleave': 'hide',
		'drop': 'drop'
	},

	/**
	 * @param {Boolean} [visible] true if the overlay should always be visible
	 */
	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		this.$el.append(template(this.context()))
		if (this.options.visible) {
			this.show()
		}

		if (this.options.clickable) {
			this.$el.addClass('is-clickable')
				.on('click', e => this.trigger('click', e))
		}
		return this
	},

	context: function () {
		let message = _.get(this.options, 'message',
			i18n.get('documents.upload.drop.revision.1'))
		let uploadIcon = _.get(this.options, 'uploadIcon', 'upload')
		return {message, uploadIcon}
	},

	drag: function(e) {
		e.stopPropagation()
		e.preventDefault()
		// change appearance of mouse cursor
		e.originalEvent.dataTransfer.dropEffect = 'copy'
	},

	drop: function(e) {
		e.preventDefault()
		e.stopPropagation()
		this.hide()
		this.trigger('drop', e)
	},

	show: function() {
		this.$el.removeClass('is-not-displayed')
	},

	hide: function() {
		if (this.options.visible) {
			return
		}
		this.$el.addClass('is-not-displayed')
	}
})

export default FileDropOverlay

FileDropOverlay.__filename__ = 'components/files/file-drop-overlay.js'
